import moment from "moment/moment";
export default {
  install (Vue) {
    Vue.prototype.$formatNum = (num) => {
      if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
        alert("wrong!");
        return num;
      }
      var a = RegExp.$1;
        var b = RegExp.$2;
        var c = RegExp.$3;
      var re = new RegExp().compile("(\\d)(\\d{3})(,|$)");
      while (re.test(b)) b = b.replace(re, "$1,$2$3");
      return a + "" + b + "" + c;
    };

    // 数组对象去重
    Vue.prototype.$arrayUnique = (arr, name) => {
      const hash = {};
      return arr.reduce(function (item, next) {
        // eslint-disable-next-line no-unused-expressions
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
        return item;
      }, []);
    };

    // 动态获取当前月份前后几个月
    Vue.prototype.$randomMonth = (n) => {
      const _this = Vue.prototype;
      var d = new Date();
      d.setDate(1)
      d.setMonth(d.getMonth() + n);
      return _this.$moment(d).format('YYYY-MM')
    }
    // 动态获取当前月份前后几个月的日期
    Vue.prototype.$randomDate = (n) => {
      const _this = Vue.prototype;
      var d = new Date();
      d.setMonth(d.getMonth() + n);
      return _this.$moment(d).format('YYYY-MM-DD')
    }
    // 去除调用参数的左右空格（只涉及字符串）
    Vue.prototype.$removeLAndRSpace = (obj) => {
      if (obj.constructor !== Object) {
        return;
      }
      for (const key in obj) {
        if (typeof (obj[key]) === "string") {
          obj[key] = obj[key].trim();
        }
      }
    }

    Vue.prototype.$checkPhone = (phone) => {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
        return false;
      }
      return true;
    }
    // 日期转换
    Vue.prototype.momentFun = (val, item) => {
      // console.log(item,'++++++++')
      item = item || 'YYYY-MM-DD'
      // console.log(item,'itemshi')
      if (val) {
        return moment(val).format(item)
      } else {
        return ''
      }
    }
    // 判断参数是""/null/undefined 为true
    Vue.prototype.isNull = (arg1) => {
      return !!(!arg1 && arg1 !== 0 && typeof arg1 !== "boolean");
    }
    // 转换两位小数
    Vue.prototype.fix2Num = (val) => {
      return Math.round(Number(val || 0) * 100) / 100
    }
    // 转换两位小数的百分比 百分比符号看需求自行添加
    Vue.prototype.fix2NumPercent = (val, symbol) => {
      return Math.round(Number(val || 0) * 10000) / 100 + (symbol || '')
    }
    // 转换4位小数
    Vue.prototype.fix4Num = (val) => {
      return Math.round(Number(val || 0) * 10000) / 10000
    }
  }
}
